"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCoolingOffLimit = void 0;
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var useCoolingOffLimit = function () {
    var _a, _b;
    var _c = (0, useQuery_1.useQuery)({
        path: keys_1.GET_COOL_OFF_LIMITS,
    }), data = _c.data, error = _c.error, isLoading = _c.isLoading, isValidating = _c.isValidating;
    return {
        data: (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b[0],
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
    };
};
exports.useCoolingOffLimit = useCoolingOffLimit;
